import { Directive, ElementRef, HostListener } from '@angular/core';

// Prevents mouse-wheel from incrementing/decrementing number inputs while still
// allowing the page to scroll normally.
@Directive({ selector: 'input[type="number"]' })
export class NoScrollNumberDirective {
  constructor(private readonly el: ElementRef<HTMLInputElement>) {}

  @HostListener('wheel', ['$event'])
  onWheel(_: WheelEvent): void {
    this.el.nativeElement.blur();
  }
}
